export const getState = (state, key) => state.appState[key];
export const getCodeWordsValidated = (state) => state.appState.codeWordsValidated;
